const settings = {
    classNames: {
        open: 'references--open',
        closing: 'references--closing',
    },

    selectors: {
        button: 'button',
        list: 'ol',
    },

    containerSelector: 'section.references',
};

export default class References {
    constructor(container) {
        this.container = container;
        this.button = this.container.querySelector(settings.selectors.button);
        this.list = this.container.querySelector(settings.selectors.list);
        this.timeline = null;
        this.open = false;

        // Stop if our elements weren't found
        if (!this.button || !this.list) {
            return;
        }

        // Setup events
        this.button.addEventListener(
            'click',
            function() {
                // Stop any ongoing animation
                if (this.timeline) {
                    this.timeline.progress(1);
                }

                this.timeline = gsap.timeline();

                if (this.open) {
                    // Closing
                    this.open = false;

                    this.container.classList.remove(settings.classNames.open);
                    this.container.classList.add(settings.classNames.closing);

                    this.timeline.to(
                        this.list,
                        0.5,
                        {
                            ease: 'power3.out',
                            height: 0,
                        },
                    );

                    this.timeline.add(
                        function() {
                            this.timeline = null;

                            this.list.removeAttribute('style');
                            this.container
                                .classList
                                .remove(settings.classNames.closing);
                        }.bind(this),
                    );
                } else {
                    // Opening
                    this.open = true;

                    this.container.classList.add(settings.classNames.open);

                    this.timeline.from(
                        this.list,
                        0.5,
                        {
                            ease: 'power3.out',
                            height: 0,
                        },
                    );

                    this.timeline.add(
                        function() {
                            this.timeline = null;
                            this.list.removeAttribute('style');
                        }.bind(this),
                    );
                }
            }.bind(this),
        );
    }

    static init() {
        // Find elements with the expected class name
        const elements = document
            .querySelectorAll(settings.containerSelector);

        for (let i=0; i<elements.length; i++) {
            new References(elements[i]);
        }
    }
}
